import { useState } from 'react';

export const useProjectTypeFilter = (initialTypes = ['single', 'bulk']) => {
  const [selectedProjectTypes, setSelectedProjectTypes] = useState(initialTypes);

  const toggleType = (type) => {
    if (selectedProjectTypes.includes('listing_score')) {
      setSelectedProjectTypes([type]);
      return;
    }
    if (selectedProjectTypes.includes(type)) {
      const without = selectedProjectTypes.filter(t => t !== type);
      if (without.length > 0) setSelectedProjectTypes(without);
    } else {
      setSelectedProjectTypes([...selectedProjectTypes, type]);
    }
  };

  const toggleSingleListing = () => toggleType('single');
  const toggleBulkListing = () => toggleType('bulk');

  const toggleListingScore = () => {
    if (selectedProjectTypes.includes('listing_score')) {
      setSelectedProjectTypes(['single', 'bulk']);
    } else {
      setSelectedProjectTypes(['listing_score']);
    }
  };

  return {
    selectedProjectTypes,
    setSelectedProjectTypes,
    toggleSingleListing,
    toggleBulkListing,
    toggleListingScore
  };
};
